import styled from 'styled-components'
import { Sizes, Breakpoints, Colors } from './../../utils/variables'
 
export const HeaderWrapper = styled.header`
    position: fixed;

    top: ${props => props.visible ? `-100px` : `0`};
    left: 0;
    z-index: 2;

    width: 100%;

    ${props => props.isTop ? `
        background-color: transparent;
    ` : `
        background-color: ${Colors.white};
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    `}

    transition: background-color 0.15s ease-out, top 0.3s ease-out, padding 0.3s ease-out;

    @media screen and (min-width: ${Breakpoints.wide}) {
        top: ${props => props.visible ? `-100px` : `0`};

        padding: 70px 0;

        ${props => props.isTop ? `
            background-color: transparent;
        ` : `
            padding: 30px 0;
            background-color: ${Colors.white};
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        `}

        &:after {
            display: none;
        }
    }
`

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    width: 100%;
    max-width: ${Sizes.maxContainerWidth};

    margin: 0 auto;

    > ul {
        display: none;
    }

    @media screen and (min-width: ${Breakpoints.wide}) {
        justify-content: space-between;
        padding: 0 70px;

        > ul {
            display: flex;
        }
    }

    @media screen and (min-width: ${Sizes.maxContainerWidth}) {
        padding: 0;
    }
`